var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _circle, _circle2, _circle3, _circle4, _circle5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDaftarIllustTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 170,
    viewBox: "0 0 203 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.064,
    cy: 84.2144,
    rx: 84.1275,
    ry: 84.1274,
    fill: "url(#paint0_linear_536_46)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.1952 49.7864C75.3113 39.0233 82.5151 34.3761 86.9452 33.2726C95.9009 30.8729 100.382 37.6639 102.183 41.4335C104.426 46.1231 106.69 58.1624 107.726 63.6925L107.756 63.8476C108.344 63.5358 108.966 63.2929 109.61 63.1239L123.929 59.2872C129.719 57.7358 135.695 61.1864 137.247 66.9762C138.048 69.9676 137.812 72.9308 136.446 75.3454C140.779 76.0182 144.417 78.8901 145.527 83.0321C146.544 86.8289 145.718 90.6185 142.869 93.3628C146.432 94.4409 149.29 97.0761 150.251 100.661C151.352 104.77 150.293 108.88 146.839 111.652C148.614 112.711 150.013 114.62 150.842 117.715C152.215 122.837 149.734 127.965 142.827 129.816L128.508 133.652C128.341 133.697 128.174 133.742 128.008 133.774L116.388 136.888C77.8187 147.907 68.8298 123.401 66.095 113.194C60.9675 94.0583 67.9718 86.0834 74.1961 78.9977C77.1409 75.6468 79.9119 72.4937 81.1441 68.4522C82.1766 65.0608 81.5638 62.3729 78.1925 49.7911L78.1952 49.7864Z",
    fill: "url(#paint1_linear_536_46)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3886 49.917C75.5046 39.1539 82.7085 34.5067 87.1386 33.4032C96.0942 31.0035 100.575 37.7945 102.377 41.5641C104.62 46.2537 106.883 58.293 107.919 63.8231L107.949 63.9782C108.537 63.6664 109.16 63.4235 109.804 63.2545L124.122 59.4178C129.912 57.8665 135.889 61.317 137.44 67.1068C138.242 70.0982 138.005 73.0614 136.64 75.476C140.973 76.1488 144.61 79.0207 145.72 83.1627C146.738 86.9595 145.911 90.7491 143.062 93.4934C146.625 94.5715 149.483 97.2068 150.444 100.792C151.545 104.901 150.486 109.011 147.032 111.782C148.808 112.842 150.206 114.751 151.036 117.846C152.408 122.968 149.927 128.096 143.02 129.946L128.702 133.783C128.535 133.828 128.368 133.872 128.201 133.905L116.581 137.019C78.012 148.037 69.0231 123.532 66.2883 113.325C61.1608 94.1889 68.1652 86.214 74.3894 79.1283C77.3342 75.7775 80.1053 72.6244 81.3375 68.5828C82.37 65.1914 81.7572 62.5035 78.3859 49.9217L78.3886 49.917Z",
    fill: "url(#paint2_linear_536_46)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3886 49.917C75.5046 39.1539 82.7085 34.5067 87.1386 33.4032C96.0942 31.0035 100.575 37.7945 102.377 41.5641C104.62 46.2537 106.883 58.293 107.919 63.8231L107.949 63.9782C108.537 63.6664 109.16 63.4235 109.804 63.2545L124.122 59.4178C129.912 57.8665 135.889 61.317 137.44 67.1068C138.242 70.0982 138.005 73.0614 136.64 75.476C140.973 76.1488 144.61 79.0207 145.72 83.1627C146.738 86.9595 145.911 90.7491 143.062 93.4934C146.625 94.5715 149.483 97.2068 150.444 100.792C151.545 104.901 150.486 109.011 147.032 111.782C148.808 112.842 150.206 114.751 151.036 117.846C152.408 122.968 149.927 128.096 143.02 129.946L128.702 133.783C128.535 133.828 128.368 133.872 128.201 133.905L116.581 137.019C78.012 148.037 69.0231 123.532 66.2883 113.325C61.1608 94.1889 68.1652 86.214 74.3894 79.1283C77.3342 75.7775 80.1053 72.6244 81.3375 68.5828C82.37 65.1914 81.7572 62.5035 78.3859 49.9217L78.3886 49.917Z",
    fill: "url(#paint3_linear_536_46)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.452 63.4341C104.697 64.5636 94.197 69.6166 96.5589 78.4313C97.802 83.0706 100.242 85.2133 102.716 86.1056C100.879 87.5923 99.9464 91.5338 101.09 95.8019C102.363 100.553 107.237 102.978 107.237 102.978C107.237 102.978 104.322 107.864 105.549 112.444C106.476 115.903 108.675 118.051 111.567 119.137C110.452 120.232 108.514 123.508 109.682 127.869C111.076 133.068 117.098 136.125 126.711 133.967C121.849 134.351 118.459 130.708 117.38 126.681C117.024 125.353 116.948 123.082 117.679 120.865L138.274 115.347C138.766 115.215 139.185 114.893 139.44 114.452C139.695 114.01 139.764 113.486 139.632 112.994C139.5 112.502 139.178 112.082 138.737 111.827C138.296 111.572 137.771 111.503 137.279 111.635L117.197 117.016C115.166 115.452 113.74 113.098 113.076 110.622C112.663 109.078 112.577 106.428 113.438 103.866L133.74 98.4263C134.232 98.2944 134.652 97.9724 134.906 97.5312C135.161 97.0899 135.23 96.5655 135.098 96.0733C134.966 95.5812 134.644 95.1616 134.203 94.9068C133.762 94.652 133.237 94.583 132.745 94.7149L113.26 99.9359C110.809 98.4047 109.1 95.78 108.353 92.9927C107.998 91.6677 107.883 89.5185 108.406 87.3138L129.265 81.7248C129.757 81.593 130.176 81.271 130.431 80.8297C130.686 80.3885 130.755 79.8641 130.623 79.3719C130.491 78.8797 130.169 78.4601 129.728 78.2053C129.287 77.9506 128.762 77.8815 128.27 78.0134L109.071 83.1578C106.384 81.503 104.466 78.4884 103.784 75.9424C102.979 72.9361 102.843 65.8521 108.472 63.5084L108.452 63.4341Z",
    fill: "#DF6F59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.981 112.848C192.482 114.28 191.133 115.834 190.013 117.588C189.563 118.292 189.445 118.962 189.688 119.784C190.302 121.871 190.832 123.98 191.394 126.081C192.052 126.225 192.346 125.716 192.589 125.304C193.878 123.115 195.768 121.537 197.777 120.075C198.202 119.767 198.484 119.332 198.847 118.969L198.844 118.97C199.194 118.027 199.139 117.145 198.469 116.349C198.189 116.016 198.068 115.627 198.105 115.196C198.205 114.046 197.756 113.084 197.1 112.181C196.422 111.248 195.62 111.133 194.839 111.977C194.563 112.278 194.269 112.557 193.981 112.848Z",
    fill: "#F15F60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4111 153.759C16.4245 154.25 18.3697 154.921 20.2172 155.88C20.9584 156.265 21.396 156.786 21.5967 157.619C22.1081 159.734 22.7042 161.825 23.267 163.926C22.7699 164.38 22.2603 164.085 21.8442 163.85C19.6336 162.599 17.2076 162.177 14.7373 161.916C14.2142 161.862 13.7526 161.626 13.257 161.493L13.26 161.492C12.4857 160.851 12.0921 160.059 12.2745 159.035C12.3508 158.607 12.2606 158.21 12.0133 157.855C11.3515 156.908 11.2594 155.851 11.3765 154.741C11.4969 153.594 12.1336 153.093 13.2323 153.434C13.6214 153.556 14.0161 153.651 14.4111 153.759Z",
    fill: "#F15F60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.84 16.0063C183.517 17.6161 184.296 19.1695 185.351 20.568C185.889 20.7836 186.262 20.7158 186.653 20.1802C187.36 19.2166 188.251 18.3948 189.048 17.498L189.058 17.4887C190.124 16.6784 191.045 15.6929 192.239 15.0331C192.933 14.6495 193.242 13.9286 193.032 13.1587C192.534 11.3129 192.117 9.44221 191.505 7.6302C191.243 6.85516 190.773 6.1648 189.796 6.93186C189.472 7.01549 189.145 7.10296 188.821 7.18659C187.485 8.91143 185.676 10.1608 184.3 11.8931C183.257 13.2123 182.61 14.3738 182.84 16.0063Z",
    fill: "#FFC70F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84182 25.6176C10.5193 27.2274 11.2984 28.7808 12.3533 30.1793C12.8905 30.3949 13.2643 30.3272 13.6552 29.7916C14.3623 28.8279 15.2532 28.0061 16.0495 27.1093L16.06 27.1C17.1256 26.2897 18.0471 25.3043 19.2405 24.6444C19.9345 24.2608 20.2435 23.5399 20.0339 22.77C19.5361 20.9242 19.1191 19.0535 18.5073 17.2415C18.2445 16.4665 17.7745 15.7761 16.7977 16.5432C16.4735 16.6268 16.1471 16.7143 15.8229 16.7979C14.4873 18.5228 12.6777 19.7721 11.3019 21.5045C10.2593 22.8236 9.61172 23.9851 9.84182 25.6176Z",
    fill: "#FFC70F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_536_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.879 157.995C145.348 159.12 145.887 160.206 146.613 161.185C146.981 161.338 147.236 161.292 147.501 160.92C147.981 160.251 148.586 159.682 149.127 159.06L149.134 159.053C149.859 158.493 150.485 157.809 151.298 157.354C151.771 157.089 151.979 156.588 151.833 156.051C151.485 154.762 151.193 153.456 150.768 152.191C150.585 151.65 150.261 151.166 149.597 151.697C149.376 151.754 149.153 151.814 148.932 151.871C148.026 153.068 146.794 153.932 145.86 155.134C145.153 156.049 144.715 156.857 144.879 157.995Z",
    fill: "#FFC70F"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.34198,
    cy: 4.34198,
    r: 4.34198,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 41.1719 41.7612)",
    fill: "#AE5FCA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.34198,
    cy: 4.34198,
    r: 4.34198,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 194.248 74.6357)",
    fill: "#AE5FCA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.17099,
    cy: 2.17099,
    r: 2.17099,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 1.12402 102.318)",
    fill: "#AE5FCA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.17099,
    cy: 2.17099,
    r: 2.17099,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 149.625 145.724)",
    fill: "#AE5FCA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.17099,
    cy: 2.17099,
    r: 2.17099,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 166.994 9.28833)",
    fill: "#AE5FCA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_536_46",
    x: 140.845,
    y: 151.468,
    width: 15.0342,
    height: 17.7993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_536_46"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_536_46",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_46",
    x1: 17.9365,
    y1: -16.2712,
    x2: 142.726,
    y2: 152.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749499,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_536_46",
    x1: 88.4046,
    y1: 32.8797,
    x2: 116.284,
    y2: 136.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B7A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7907F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_536_46",
    x1: 88.5299,
    y1: 33.0285,
    x2: 116.41,
    y2: 137.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.631043,
    stopColor: "#E90111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981672,
    stopColor: "#A8010D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_536_46",
    x1: 76.8251,
    y1: 39.562,
    x2: 116.478,
    y2: 137.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B7A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7D67"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaftarIllustTop);
export default __webpack_public_path__ + "static/media/daftar-illust-top.d53149f84e4b92eb6b0a18b95995aa6c.svg";
export { ForwardRef as ReactComponent };